const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const VerifiedDomainsTable = createReactClass({
	getInitialState: function() {
		return {
			removingDomain: false
		};
	},

	getModal: function (form, title) {
		if(!form) {
			return null;
		}
		return (
			<Modal
				closeHandler={this.cancelHandler}
				title={title}
			>
				{form}
			</Modal>
		);
	},

	cancelHandler: function(event) {
		if(event) {
			event.preventDefault();
		}
		this.setState({
			removingDomain: false
		});
	},

	showRemoveModal: function(data) {
		this.setState({
			removingDomain: data,
		});
	},

	render: function() {
		let domains = this.props.domains;
		let self = this;
		let domainRows = Object.keys(domains).map(function(key) {
			return (
				<DomainRow
					key={domains[key].ID}
					id={domains[key].ID}
					name={domains[key].Name}
					challengeName={domains[key].Record}
					challengeValue={domains[key].Value}
					verified={domains[key].Verified}
					allowDelete={self.props.allowDelete}
					deleteAction={() => self.props.onDelete(domains[key])}
				/>
			);
		});

		return (
			<div>
				<table className="table table-striped">
					<thead>
					<tr>
						<th>Domain</th>
						<th>CNAME record</th>
						<th>CNAME value</th>
						<th>Challenge verified?</th>
					</tr>
					</thead>
					<tbody>
					{domainRows}
					</tbody>
				</table>
			</div>
		);
	}
});

function DomainRow(props) {
	let status = (
		<div className="pending-verification">
			Pending verification
		</div>
	);

	if (props.verified) {
		status = (
			<div className="verified">
				Verified
			</div>
		);
	}

	let idnTooltip;
	if (props.name && props.name.includes('xn--')) {
		idnTooltip = (
			<i className="fa fa-info-circle fa-fw pull-right tooltip-hint" title="This domain contains non-ASCII characters and has been converted to it's Internationalized Domain Name representation."></i>
		)
	}

	let deleteAction;
	if (props.allowDelete) {
		deleteAction = (
			<button type="button" className="btn btn-xs btn-danger" onClick={props.deleteAction}>
				<i className="fa fa-times no-text" title="Remove domain" />
			</button>
		);
	}

	return (
		<tr>
			<td>{props.name}{idnTooltip}</td>
			<td>{props.challengeName}</td>
			<td>{props.challengeValue}</td>
			<td>{status}</td>
			<td>{deleteAction}</td>
		</tr>
	);
}

module.exports = VerifiedDomainsTable;
